const config={
    enum:{
        permissionfid:34,                       //权限分类-2
        sitetypeid:26,                          //站点类型-2
        sitecateid:27,                          //平台分类-2
        rolefid:37,                             //角色分类-2
        depttypefid:55,                         //部门分类-1
        doccatefid:65,                          //文档分类-1
        productcatefid:66,                      //产品类别-1
        docrecommendposition:63,                //文档推荐位-1
        prdrecommendposition:75,                //产品推荐位-1
        advrecommendposition:76,                //adv推荐位-1
        systemdocinfo:83,                        //系统信息-1

        //system
        sys_copyrightid:'7141794220046237696',      //备案授权

        //cache
        cache_qrcode:'cache_qrcode',
        cache_copyright:'cache_copyright',
        cache_menu:'menutree',
        cache_banner:'bannerlist',
        news_outside_link:'https://host318.com/index.php/Home/News/newsList/id1/11',

        homepage1:'6819410084809621504',            //首页大图(ok)
        homepage5:'6819991441965268992',                //广告分类-联系我们(ok)
        homepage6:'6818659304548810888',               //QHSE管理分类id(ok)


        //广告id start--------------------
        //简介下方3广告pid
        pidinfobot:'',       
        //
        //advpid:'6819409848070520832',           //  广告分类
        adv_bannerpid:'6819993946421936128',        //内容bannnerpid
        adv_qrcodepid:'7137476244887257088',        //  二维码pid
        adv_corp:'6819410418659442688',             //合作伙伴
        
        //广告id end----------------------------------

        //菜单主id
        mainid:'6729206328126554112',                   //(ok)
        menucodestart:'doc-aboutus-',           //菜单项-关于我们子菜单(ok)
        //关于我们
        pidguanyuwomen:'6727725576222359552',               //关于我们主id(ok)
        pidjianjie:'6819583732740734976',                //公司简介(ok)
        pidwenhua:'6819583941617074176',                   //企业文化
        pidlianxi:'6818663487305891840',                   //联系方式(ok)
        pidpartner:'6819410418659442688',                  //合作伙伴
        pidhonor:'7137455252894859264',                     //公司荣誉
        //主营业务              
        pidbiz:'6818659304548810752',                       //(ok)
        pidleadertrain:'6818660383848087552',  //干部培训
        pidtalentstrain:'6818660557886537728', //人才培训
        pidedutrain:'6818660640526909440',     //教育研学
        //新闻
        pid_news_main:'6818659373977124864',     //新闻中心主id
        pidgroupnews:'6818662767529771008',    // 恒定动态
        pidtradenews:'6818663137698070528',    // 贸易业务
        pidnotice:'6819585233890525184',       // 物流运输
        cngupload:'7137470829902381056',    //CNG上载业务

         //加入我们
         pidcontactus:'6818659416872271872',        //联系我们
         pidemployeecare:'6818663487305891840',     //联系方式
         pidemployment:'6818663566163001344',           //社会招聘
         pidshool:'6819585438769692672',           //校园招聘

        //temp can delete------------------------------------------------------------------

        //公开
        pidpublicguide:'6878291483796652032',    // 公开指南
        pidpublicstipulate:'6878291887783624704',    // 公开规定
        pidpubliccatalog:'6878291972823138304',       // 公开目录

       

    }
}

export default {config }